/* Class and set of functions for communication with Feide and Dataporten */
import axios from 'axios'
// const jwtDecode = require('jwt-decode')
// import jwtDecode from 'jwt-decode'

const apiVersjon = '?api-version=4.0'

export class UdirTools {
  constructor() {
    this.udirAPIServer = 'https://data-nbr.udir.no'
    this.udirAPIServerSchool = 'https://data-nsr.udir.no'
  }

  getAxiosConnection(url, path) {
    // let accessClientToken = localStorage.getItem('access_client_token')
    // let url = context.getters.getServerUrl
    console.log('getAxiosConnection url(' + url + ') path(' + path + ')')
    return axios.create({
      baseURL: url + path,
      // timeout: 5000,
      timeout: 10000,
      responseType: 'json', // default
      responseEncoding: 'utf8', // default
      maxRedirects: 5, // default
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
        //  'Authorization': 'Bearer ${accessClientToken}',
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Headers': 'access-control-allow-origin'
        //    'Access-Control-Allow-Methods': GET
      }
    })
  }

  async getAllMunicipaliyCounties() {
    console.log('getAllMunicipaliyCounties got called')
    return new Promise((resolve, reject) => {
      console.log('getAllMunicipaliyCounties got called ! : ' + this.token)
      const instance = this.getAxiosConnection(this.udirAPIServer, '')
      let activeOrgs = []
      instance
        .get('/fylker', {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          let orgs = response.data || []
          orgs.forEach((value) => {
            if (!value.ErNedlagt && value.OrgNr) {
              activeOrgs.push({
                municipalitycounty_name: value.Navn,
                municipalitycounty_id: value.Fylkesnr
              })
            }
          })
          resolve(activeOrgs)
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    })
  }

  async getAllMunicipality(countyNumber) {
    console.log('getAllMunicipality got called')
    return new Promise((resolve, reject) => {
      console.log('getAllMunicipality got called ! : ' + countyNumber)
      const instance = this.getAxiosConnection(this.udirAPIServer, '')
      let activeOrgs = []
      instance
        .get('/kommuner/' + countyNumber, {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          let orgs = response.data || []
          orgs.forEach((value) => {
            if (!value.ErNedlagt && value.OrgNr) {
              //    console.log('ADDING (%s)', value.Navn)
              activeOrgs.push({
                municipality_name: value.Navn,
                municipality_id: value.Kommunenr,
                municipality_OrgNr: value.OrgNr
              })
            }
          })
          resolve(activeOrgs)
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    })
  }

  async getAllSchools(countyNumber) {
    return new Promise((resolve, reject) => {
      console.log('getAllSchools got called ! : ' + countyNumber)
      const instance = this.getAxiosConnection(this.udirAPIServerSchool, '/v4/enheter')
      let activeOrgs = []
      instance
        .get('/kommune/' + countyNumber + apiVersjon, {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((response) => {
          // console.log(response)
          let resData = response.data || []
          let orgs = resData.EnhetListe || []
          // orgs.forEach((value) => {
          for (let i = 0; i < orgs.length; i++) {
            let value = orgs[i]
            // console.log('VALUE (%J)', value)
            // if (value.OrgNr && value.NaceKode1 === '85.201') {
            if (value.ErAktiv && value.ErGrunnskole) {
              //       console.log('VALUE (%s)', JSON.stringify(value))
              activeOrgs.push(value)
            }
          }
          resolve(activeOrgs)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    })
  }

  async getAllKindergartens(kommuneorgnr) {
    console.log('getAllKindergartens got called (' + kommuneorgnr + ')')
    return new Promise((resolve, reject) => {
      if (kommuneorgnr === undefined) {
        reject(new Error('NO kommunenr defined'))
      }
      // let kommunenr = kommuneorgnr.substr(2)
      // /trestruktur/940039541/1
      let query = '/v3/enheter/kommune/' + kommuneorgnr
      const instance = this.getAxiosConnection(this.udirAPIServer, '')
      console.log('QUERY : ' + query)
      instance
        .get(query, {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((kindergartens) => {
          // console.log(kindergartens.data)
          let kgData = kindergartens.data
          resolve(kgData)
          /*
            let returnSchools = []
            kgData.forEach((value) => {
              returnSchools.push({
                navn:value.Navn,
                orgnr: value.OrgNr,
              })
            resolve(returnSchools)
            */
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllKindergartens:' + error)
          reject(new Error('*** ERROR *** getAllKindergartens:' + error))
        })
    }) // promise
  }

  async getOneKindergarten(orgnr) {
    console.log('getOneKindergarten got called (' + orgnr + ')')
    return new Promise((resolve, reject) => {
      if (orgnr === undefined) {
        reject(new Error('NO orgnr defined'))
      }

      // let kommunenr = kommuneorgnr.substr(2)
      // /trestruktur/940039541/1
      let query = '/v3/enhet/' + orgnr
      const instance = this.getAxiosConnection(this.udirAPIServer, '')
      console.log('QUERY : ' + query)
      instance
        .get(query, {
          headers: {
            //  Authorization: `Bearer ${this.token}`, // OPEN API
            // 'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        })
        .then((kindergartens) => {
          console.log(kindergartens.data)
          let kgData = kindergartens.data
          resolve(kgData)
          /*
            let returnSchools = []
            kgData.forEach((value) => {
              returnSchools.push({
                navn:value.Navn,
                orgnr: value.OrgNr,
              })
            resolve(returnSchools)
            */
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllKindergartens:' + error)
          reject(new Error('*** ERROR *** getAllKindergartens:' + error))
        })
      // let kommunenr = kommuneorgnr.substr(2)

    })// promise
  }

}
